import { useMutation } from '@tanstack/react-query'
import { instance, instance2 } from './fetch'
import OnboardingFeedback from '../../pages/Feedback/Feedback';
export function useRegisterCustomer() {
  const registerAPI = async (_payload: Partial<IOnboardPayload>) => {
    const { data } = await instance.post(
      '/onboarding-service/api/v1/Customer/Onboarding/IndividualCustomer',
      _payload,
    )
    return data
  }

  const mutateRegister = useMutation({ mutationFn: registerAPI })
  return mutateRegister
}

interface ISaveForLaterPayload{
  "emailAddress": string
    "phoneNumber": string,
      "firstName":string, 
   "lastName": string
}
export function useSaveForLaterCustomer() {
  const saveForLaterAPI = async (_payload: ISaveForLaterPayload) => {
    const { data } = await instance.post(
      '/onboarding-service/api/v1/Customer/Onboarding/SaveLater',
      _payload,
    )
    return data
  }

  const mutateRegister = useMutation({ mutationFn: saveForLaterAPI })
  return mutateRegister
}

interface IBVNPayload {
  bvn: string
  emailAddress: string
  otp: string
}
export const useFetchBVNDetails = () => {
  async function fetchBVNDetails(payload: IBVNPayload) {
    const { data } = await instance.post(
      `/onboarding-service/api/v1/Customer/BVN/GetDetails`,
      payload,
    )

    // console.log({data})
    return data
  }

  const queryBVNDetails = useMutation({
    mutationFn: fetchBVNDetails,
    mutationKey: ['fetch-bvn-details'],
  })
  return queryBVNDetails
}

interface IConfirmPaymentPayload {
  transactionReference: string
  paymentSource: 1 | 2 | 3 | 4 | 5
  amountPaid: number
  paymentProcessorsReference: string
}
export const useConfirmPayment = () => {
  async function confirmPayment(payload: IConfirmPaymentPayload) {
    const { data } = await instance.post(
      `/onboarding-service/api/v1/Customer/Onboarding/TransactionConfirmation`,
      payload,
    )
    return data
  }
  const mutatePayment = useMutation({
    mutationFn: confirmPayment,
    mutationKey: ['confirm-payment'],
  })
  return mutatePayment
}
export const useDeleteRecord = () => {
  const deleteRecord = async (payload: {
    email: string
    productSubscriptionFundType: 1 | 2 | 3 | 4
  }) => {
    const { data } = await instance.delete(
      `/onboarding-service/api/v1/Customer/Onboarding/DeleteUnpaidRequest`,
      {
        data: payload,
      },
    )
    return data
  }
  const mutateDelete = useMutation({
    mutationFn: deleteRecord,
    mutationKey: ['delete-record'],
  })
  return mutateDelete
}

interface OnboardingFeedback{
  comment:string
  rating:number
  email:string

}
export const useAddOnboardingFeedback=()=>{
  const addOnboardingFeedback = async (payload:OnboardingFeedback)=>{
const {data}= await instance2.post(`/onboard/add-feedback`,payload)
return data
  }

  const mutation = useMutation({
    mutationFn:addOnboardingFeedback
  })
return mutation
}